import { Link } from "react-router-dom";
import { ExternalLink, MapPin } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { imgUrl } from "../api";

const DEFAULT_STORE_ADDRESS =
  "Nizampet Main Rd, Survey 37, Nagarjuna Homes, Nizampet, Hyderabad, Telangana 500085.";

export default function Footer() {
  const { settings, homepage } = useSettings();
  const waNum = (settings.whatsapp_number || "").replace(/\D/g, "");
  const footer = homepage.footer || {};
  const storeAddress = footer.address || DEFAULT_STORE_ADDRESS;
  const encodedAddress = encodeURIComponent(storeAddress);
  const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-grid">
        <div className="footer-col footer-brand">
          <img
            src={imgUrl("/assets/logo.png")}
            alt={settings.brand_name}
            className="footer-logo"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
          <span className="logo-mark" style={{ display: "none" }}>{settings.brand_name}</span>
          <div className="footer-brand-address">
            <span className="eyebrow">Our Store Location</span>
            <address>
              <a href={mapLink} target="_blank" rel="noreferrer">{storeAddress}</a>
            </address>
            <a
              href={mapLink}
              target="_blank"
              rel="noreferrer"
              className="footer-map-link"
              data-testid="footer-map-link"
            >
              <MapPin size={13} aria-hidden="true" /> Open in Maps <ExternalLink size={12} aria-hidden="true" />
            </a>
          </div>
        </div>
        <div className="footer-col">
          <span className="eyebrow">Shop</span>
          <Link to="/shop" data-testid="footer-shop-link">All looks</Link>
          <Link to="/shop/collection">Collection</Link>
          <Link to="/shop/mens-wear" data-testid="footer-men-link">Men's Wear</Link>
          <Link to="/shop/womens-wear" data-testid="footer-women-link">Women's Wear</Link>
          <Link to="/shop/kids-wear">Kids Wear</Link>
        </div>
        <div className="footer-col">
          <span className="eyebrow">Customer care</span>
          <Link to="/about" data-testid="footer-about-link">About the house</Link>
          <Link to="/contact" data-testid="footer-contact-link">Contact & Customization</Link>
          <Link to="/policies#privacy" data-testid="footer-policy-link">Privacy Policy</Link>
          <Link to="/policies#terms">Terms & Conditions</Link>
          <Link to="/policies#returns">Return & Refund Policy</Link>
          <Link to="/policies#shipping">Shipping & Delivery</Link>
          <Link to="/account" data-testid="footer-account-link">Account & Orders</Link>
          <Link to="/wishlist" data-testid="footer-wishlist-link">Wishlist</Link>
        </div>
        <div className="footer-col">
          <span className="eyebrow">Connect</span>
          <a href={`https://wa.me/${waNum}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link">
            WhatsApp {"\u00b7"} {settings.whatsapp_number}
          </a>
          <a href={`mailto:${settings.email}`} data-testid="footer-email-link">{settings.email}</a>
          <a href={`https://instagram.com/${settings.instagram_handle}`} target="_blank" rel="noreferrer" data-testid="footer-instagram-link">
            @{settings.instagram_handle}
          </a>
        </div>
        <div className="footer-word" aria-hidden="true">
          {footer.wordmark_line1 || "LALITA"} {footer.wordmark_line2 || "SOUJANYA"}
        </div>
      </div>
      <div className="footer-bottom">
        <span>{"\u00a9"} {new Date().getFullYear()} {settings.brand_name}. All rights reserved.</span>
        <span>{footer.footer_note || settings.footer_note}</span>
      </div>
    </footer>
  );
}
